import { Link } from "../../../types/link";

export class WebApiError extends Error {
  statusCode: number;
  errorCode: string;
  errorMessage: string;
  link: Link[];

  constructor(
    statusCode: number,
    errorCode: string,
    errorMessage: string = "",
    link: Link[] = [],
  ) {
    super(`${statusCode}: ${errorCode}`);

    this.statusCode = statusCode;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.link = link;
  }
}
